module.exports = __webpack_public_path__ + "img/sCandyBona_350x350.7b5341d0.jpg";